import { css } from '@emotion/css';

export const idleStyles = 'transform transition-all ease-out duration-500';

export const dialogButtonStyles =
  'rounded-full w-36 h-36 bg-interactive-secondary hover:bg-interactive-white-hover';

export const pageStackStyles = css`
  ::before,
  ::after {
    content: '';
    z-index: -4;
    position: absolute;

    height: calc(100% - 2.4rem);
    background: var(--bg-primary);
    border: 1px solid var(--border);
    box-shadow: var(--shadow-01);
    border-radius: 0.8rem;
  }

  ::before {
    top: -1.6rem;
    left: 2.2rem;
    width: calc(100% - 4.4rem);
  }
  ::after {
    top: -0.8rem;
    left: 1.1rem;
    width: calc(100% - 2.2rem);
  }
`;

export const absolutePosn = css`
  position: absolute !important;
  z-index: -1;
`;

export const pdfStyles = css`
  .react-pdf__Page__canvas {
    margin-inline-start: auto;
    margin-inline-end: auto;
  }
  .react-pdf__Page__canvas {
    border-radius: 0.8rem;
  }
`;

export const pageAnimation = css`
  &.page-enter {
    transform: translateX(-7px);
  }
  &.page-enter-active {
    transform: translateX(0px);
    transition:
      all 200ms linear,
      transform 350ms;
  }
  &.page-exit {
    transform: translateX(0px);
  }
  &.page-exit-active {
    transform: translateX(7px);
    transition:
      all 200ms linear,
      transform 350ms;
  }
`;

export const loaderStyles = css`
  height: 14rem;
`;

const EDITOR_PADDING_LEFT = '6.8rem';
const LG_SCREEN_MAX_WIDTH = '1440px';

export const pdfViewerResponsiveMargin = css`
  @media (max-width: ${LG_SCREEN_MAX_WIDTH}) {
    margin-inline-start: ${EDITOR_PADDING_LEFT};
  }
`;
